/**
 * warns when a mod gets enabled that is "sticky" and will integrate into the
 * savegame in such a way that it can't be removed (at least not automatically)
 */
import renderModName from "../mod_management/util/modName";
function testModSticky(api, previous, current) {
    const state = api.store.getState();
    const mods = state.persistent.mods[current.gameId] || {};
    Object.keys(previous.modState || {}).forEach((modId) => {
        if (mods?.[modId]?.attributes?.["sticky"] === true &&
            !previous.modState[modId].enabled &&
            current.modState[modId].enabled) {
            api.sendNotification({
                type: "warning",
                message: api.translate('{{ modName }} is "sticky". Disabling it at a later time will probably ' +
                    " make all savegames created with it unusable. Keep a backup!", { replace: { modName: renderModName(mods[modId]) } }),
            });
        }
    });
}
function init(context) {
    context.once(() => {
        context.api.onStateChange(["persistent", "profiles"], (previous, current) => {
            if (previous === undefined || current === undefined) {
                return;
            }
            Object.keys(previous).forEach((profileId) => {
                if (previous[profileId] !== current[profileId] &&
                    current[profileId] !== undefined) {
                    testModSticky(context.api, previous[profileId], current[profileId]);
                }
            });
        });
    });
    return true;
}
export default init;
